import PropTypes from 'prop-types';
import { PaymentOptions } from '../constants';

export const PaymentOptionPropType = PropTypes.oneOf(Object.values(PaymentOptions));
